import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feature-five',
  templateUrl: './feature-five.component.html',
  styleUrls: ['./feature-five.component.css']
})
export class FeatureFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
